import { createContext } from 'react';

import { LayersThreeJsFacade } from 'features/seismic-3d/threejs/facade/LayersThreeJsFacade';

export const LayersThreeJsContext = createContext<LayersThreeJsFacade|null>(null);